/**
 * 系统管理  教室管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" v-if="flag != 2">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>教室管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search" @submit.native.prevent>
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.jsmc" placeholder="输入教室名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="flag != 2">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table
      ref="tableBox1"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      :row-key="(row) => { return row.id }"
    >
      <el-table-column type="selection" width="55" align="center" :reserve-selection="true" v-if="flag == 2"/>
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="jsmc" label="教室名称">
      </el-table-column>
      <el-table-column prop="jsdz" label="教室地址">
      </el-table-column>
      <el-table-column align="center" label="操作" width="200" v-if="flag != 2">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="50%" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-form-item label="打开地图" >
          <MapDialog v-on:addressData="addressData"/>
        </el-form-item>
        <el-form-item label="教室名称" prop="jsmc">
          <el-input size="small" v-model="form.jsmc" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="教室地址" prop="jsdz">
          <el-input size="small" v-model="form.jsdz" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="jd">
          <el-input size="small" v-model="form.jd" placeholder="自动代入" readonly></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="wd">
          <el-input size="small" v-model="form.wd" placeholder="自动代入" readonly></el-input>
        </el-form-item>
        <el-form-item label="签到误差（米）" prop="wc">
          <el-input size="small" v-model="form.wc" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <div style="text-align: right;" v-if="flag == 2">
      <el-button type="primary" @click="submitData">确定</el-button>
    </div>

  </div>
</template>

<script>
import { getRoomList, addRoom, editRoom, deleteRoomById } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import MapDialog from '../../components/mapDialog/mapDialog.vue'
import {timestampToTime} from "../../utils/util";

export default {
  props: {
    flag: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      roomForm: '',

      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      rules: {
        jsmc: [
          { required: true, message: '请输入教室名称', trigger: 'blur' }
        ],
        jsdz: [
          { required: true, message: '请输入教室地址', trigger: 'blur' }
        ],
        jd: [
          { required: true, message: '请输入经度', trigger: 'blur' }
        ],
        wd: [
          { required: true, message: '请输入纬度', trigger: 'blur' }
        ],
      },
      queryParams: {
        page: 1,
        size: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
    MapDialog
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata()
    },
    // 获取营销渠道列表
    getdata() {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getRoomList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log('selection  ', selection);
      if (selection.length > 1) {
        // this.$message.error('只能选择一条数据');
        this.$refs.tableBox1.clearSelection();
        this.$refs.tableBox1.toggleRowSelection(selection.pop());
      } else {
        this.roomForm = selection[0];
      }
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.form = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加'
        this.form = {}
      }
    },
    addressData(item) {
      this.$set(this.form, 'jsdz', item.selectedAddress)
      this.$set(this.form, 'jd', item.selectedLocation[0])
      this.$set(this.form, 'wd', item.selectedLocation[1])
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {

          if (this.form.id) {

            // 修改
            editRoom(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          } else {

            // 新增
            addRoom(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }


        } else {
          return false
        }
      })
    },
    // 删除营销渠道
    deleteUser(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteRoomById(row.id).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    },

    submitData() {
      if (this.roomForm && this.roomForm.id) {
        this.$emit('roomData', this.roomForm);
      } else {
        this.$message.error('请勾选需要的教室数据...')
      }
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/classroom.vue